import { useMemo } from 'react';

import { usePetitionDetailsPageData } from 'src/app/pages/petitionGamma/details/pageContext';
import type { PetitionDetailsPageData } from 'src/app/pages/petitionGamma/details/pageContext';

import type { RecentSigner } from '../../types';

type Edge = PetitionDetailsPageData['petition']['recentPublicSignersConnectionV2']['edges'][number];

function mapEdgeToRecentSigner(edge: Edge): RecentSigner {
	const {
		createdAtRelativeLocalized,
		user: { id, displayName },
	} = edge;
	return { id, displayName, createdAtRelativeLocalized };
}

export function useRecentSignersConnection(): RecentSigner[] {
	const {
		data: {
			petition: { recentPublicSignersConnectionV2 },
		},
	} = usePetitionDetailsPageData();

	return useMemo(
		() => recentPublicSignersConnectionV2.edges.map(mapEdgeToRecentSigner),
		[recentPublicSignersConnectionV2],
	);
}
